import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

interface ExportDataParams {
    timeRange: string;
    revenue: number;
    previousRevenue: number;
    newBookingsCount: number;
    previousBookingsCount: number;
    averageTicket: number;
    prevAverageTicket: number;
    newClientsCount: number;
    previousClientsCount: number;
    revenueChartData: any[];
    staffData: any[];
    servicesData: any[];
    calculateVariation: (curr: number, prev: number) => number;
}

export const exportAnalyticsToExcel = ({
    timeRange,
    revenue,
    previousRevenue,
    newBookingsCount,
    previousBookingsCount,
    averageTicket,
    prevAverageTicket,
    newClientsCount,
    previousClientsCount,
    revenueChartData,
    staffData,
    servicesData,
    calculateVariation
}: ExportDataParams) => {
    try {
        const workbook = XLSX.utils.book_new();
        const dateStr = format(new Date(), 'dd-MM-yyyy');

        // --- 1. FOGLIO "RIEPILOGO" (KPI) ---
        const summaryData = [
            ["REPORT ANALYTICS", ""],
            ["Data Estrazione", dateStr],
            ["Periodo Analizzato", timeRange.toUpperCase()],
            ["", ""],
            ["METRICA", "VALORE", "VARIAZIONE"],
            ["Fatturato Totale", `€ ${revenue.toFixed(2)}`, `${calculateVariation(revenue, previousRevenue).toFixed(1)}%`],
            ["Appuntamenti Totali", newBookingsCount, `${calculateVariation(newBookingsCount, previousBookingsCount).toFixed(1)}%`],
            ["Scontrino Medio", `€ ${averageTicket.toFixed(2)}`, `${calculateVariation(averageTicket, prevAverageTicket).toFixed(1)}%`],
            ["Nuovi Clienti", newClientsCount, `${calculateVariation(newClientsCount, previousClientsCount).toFixed(1)}%`],
        ];
        const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
        summarySheet['!cols'] = [{ wch: 25 }, { wch: 20 }, { wch: 15 }];
        XLSX.utils.book_append_sheet(workbook, summarySheet, "Riepilogo KPI");

        // --- 2. FOGLIO "ANDAMENTO" (Dati grafico) ---
        const trendHeader = [["DATA/PERIODO", "FATTURATO (€)"]];
        const trendRows = revenueChartData.map(item => [item.name, item.value]);
        const trendSheet = XLSX.utils.aoa_to_sheet([...trendHeader, ...trendRows]);
        trendSheet['!cols'] = [{ wch: 20 }, { wch: 15 }];
        XLSX.utils.book_append_sheet(workbook, trendSheet, "Andamento Temporale");

        // --- 3. FOGLIO "STAFF & SERVIZI" ---
        const detailsData: any[] = [
            ["PERFORMANCE STAFF", "", "", "TOP SERVIZI", ""],
            ["Nome", "Fatturato Generato", "", "Servizio", "Quantità"],
        ];

        const maxRows = Math.max(staffData.length, servicesData.length);

        for (let i = 0; i < maxRows; i++) {
            const staffRow = staffData[i];
            const serviceRow = servicesData[i];

            detailsData.push([
                staffRow ? staffRow.name : "",
                staffRow ? `€ ${staffRow.revenue.toFixed(2)}` : "",
                "",
                serviceRow ? serviceRow.name : "",
                serviceRow ? serviceRow.rawValue : ""
            ]);
        }

        const detailsSheet = XLSX.utils.aoa_to_sheet(detailsData);
        detailsSheet['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 5 }, { wch: 30 }, { wch: 10 }];
        XLSX.utils.book_append_sheet(workbook, detailsSheet, "Dettagli Operativi");

        // --- SALVATAGGIO ---
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        saveAs(data, `Analytics_Report_${timeRange}_${dateStr}.xlsx`);

        return true; // Successo
    } catch (error) {
        console.error("Export failed", error);
        return false; // Errore
    }
};